import { Box, SxProps } from '@mui/material';
import OpenLinkPrimary from './OpenLinkPrimary.svg';

type Props = {
  color?: 'primary' | 'default';
  width?: number;
  height?: number;
  sxProps?: SxProps;
};

export function OpenLinkIcon({
  color = 'primary',
  width = 24,
  height = 24,
  sxProps,
}: Props) {
  const icon = color === 'primary' ? OpenLinkPrimary : '';

  return (
    <Box
      component="img"
      src={icon.src}
      width={width}
      height={height}
      sx={{
        width: `${width}px`,
        height: `${height}px`,
        ...sxProps,
      }}
    />
  );
}
